import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export function ConfirmPasswordValidator(controlName: string, matchingControlName: string): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    const group = formGroup as FormGroup;
    const control = group.controls[controlName];
    const matchingControl = group.controls[matchingControlName];

    if (!control || !matchingControl) return null;

    if (matchingControl.errors && !matchingControl.errors['confirmPasswordValidator']) {
      // If some other validator already set an error, don't overwrite it
      return null;
    }

    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ confirmPasswordValidator: true });
    } else {
      matchingControl.setErrors(null);
    }

    return null;
  };
}
